export const authRoles = {
    sa: ['MASTER'], // Only Super Admin has access
    admin: ['MASTER', 'ADMIN'], // Only SA & Admin has access
    atendente: ['MASTER', 'ADMIN'], // Only SA & Admin has access
    mkt: ['MASTER', 'ADMIN'], // Only SA & Admin has access


    anunciante: ['ANUNCIANTE'],
    
    viewCamp: ['MASTER', 'ADMIN', 'ATENDENTE', 'MKT'],
    viewDash: ['MASTER', 'ADMIN', 'ATENDENTE', 'MKT'],
    viewPubli: ['MASTER', 'ADMIN', 'ATENDENTE', 'MKT'],
    viewCli: ['MASTER', 'ADMIN', 'ATENDENTE', 'MKT'],
    viewCup: ['MASTER', 'ADMIN', 'ATENDENTE', 'MKT'],
    viewRel: ['MASTER', 'ADMIN', 'ATENDENTE', 'MKT'],
    viewVP: ['MASTER', 'ADMIN', 'ATENDENTE', 'MKT'],
    viewList: ['MASTER', 'ADMIN', 'ATENDENTE', 'MKT'],
    viewFaq: ['MASTER', 'ADMIN', 'ATENDENTE', 'MKT'],
    viewPerm: ['MASTER', 'ADMIN', 'ATENDENTE', 'MKT'],
    viewConf: ['MASTER', 'ADMIN', 'ATENDENTE', 'MKT'],
    viewUsu: ['MASTER', 'ADMIN', 'ATENDENTE', 'MKT'],
    viewLog: ['MASTER', 'ADMIN', 'ATENDENTE', 'MKT'],
    viewFin: ['MASTER'],
    viewAnun: ['MASTER'],

    editDash: ['MASTER', 'ADMIN'],
    editPubli: ['MASTER', 'ADMIN'],
    editCli: ['MASTER', 'ADMIN'],
    editCup: ['MASTER', 'ADMIN'],
    editRel: ['MASTER', 'ADMIN'],
    editVP: ['MASTER', 'ADMIN'],
    editList: ['MASTER', 'ADMIN'],
    editFaq: ['MASTER', 'ADMIN'],
    editPerm: ['MASTER', 'ADMIN'],
    editUsu: ['MASTER', 'ADMIN'],
    editLog: ['MASTER', 'ADMIN'],
    editFin: ['MASTER'],
    editAnun: ['MASTER'],

    
}

// Check out app/views/dashboard/DashboardRoutes.js
// Only SA & Admin has dashboard access

// const dashboardRoutes = [
//   {
//     path: "/dashboard/analytics",
//     component: Analytics,
//     auth: authRoles.admin <===============
//   }
// ];

// Check navigaitons.js

// {
//   name: "Dashboard",
//   path: "/dashboard/analytics",
//   icon: "dashboard",
//   auth: authRoles.admin <=================
// }
